import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from '../../../api/Constants';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
import { updateUserInfoHandler } from '../utils';
import { fetchGameRooms } from '../games/utils';
var finishMobilePurchaseEndpoint = Endpoints.FINISH_MOBILE_PURCHASE;
export var postFinishMobilePurchaseMutation = {
  query: function query(data) {
    return {
      url: finishMobilePurchaseEndpoint,
      body: {
        data: data
      },
      method: 'post'
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, _ref) {
      var dispatch, queryFulfilled, purchaseResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref.dispatch, queryFulfilled = _ref.queryFulfilled;
              _context.prev = 1;
              _context.next = 4;
              return queryFulfilled;

            case 4:
              purchaseResponse = _context.sent;
              (purchaseResponse === null || purchaseResponse === void 0 ? void 0 : purchaseResponse.data) && (purchaseResponse === null || purchaseResponse === void 0 ? void 0 : purchaseResponse.data[0]) && updateUserInfoHandler(dispatch, purchaseResponse.data);
              fetchGameRooms(true);
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              handleQueryLoggerEvents(_context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};